import React from 'react';
import { motion } from 'framer-motion';

function Privacy() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="min-h-screen bg-gray-50 py-12"
    >
      <div className="container mx-auto px-4 max-w-3xl">
        <div className="bg-white rounded-xl shadow-lg p-8">
          <h1 className="text-3xl font-bold mb-6">Gizlilik Politikası</h1>
          
          <div className="prose prose-blue max-w-none">
            <p className="text-gray-600 mb-6">
              Son güncelleme tarihi: {new Date().toLocaleDateString('tr-TR')}
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">1. Kişisel Verilerin Korunması</h2>
            <p>
              Excel Vadisi olarak kişisel verilerinizin gizliliğine önem veriyoruz. Bu politika, 
              hangi bilgileri topladığımızı ve bunları nasıl kullandığımızı açıklamaktadır.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">2. Toplanan Bilgiler</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                <strong>Hesap Bilgileri:</strong> Ad, soyad, e-posta adresi, şifre
              </li>
              <li>
                <strong>Profil Bilgileri:</strong> Şirket adı, unvan, telefon numarası (isteğe bağlı)
              </li>
              <li>
                <strong>Kullanım Verileri:</strong> Site kullanım istatistikleri, tercihler
              </li>
              <li>
                <strong>Teknik Veriler:</strong> IP adresi, tarayıcı bilgileri, cihaz bilgileri
              </li>
            </ul>

            <h2 className="text-xl font-semibold mt-8 mb-4">3. Bilgilerin Kullanımı</h2>
            <p>
              Topladığımız bilgiler aşağıdaki amaçlarla kullanılmaktadır:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Hizmetlerimizi sunmak ve iyileştirmek</li>
              <li>Hesabınızı yönetmek</li>
              <li>Size özel içerik ve öneriler sunmak</li>
              <li>Güvenliği sağlamak</li>
              <li>Yasal yükümlülükleri yerine getirmek</li>
            </ul>

            <h2 className="text-xl font-semibold mt-8 mb-4">4. Bilgi Paylaşımı</h2>
            <p>
              Kişisel verileriniz, yasal zorunluluklar dışında üçüncü taraflarla paylaşılmaz. 
              Verileriniz yalnızca hizmet sağlayıcılarımızla ve yasal otoritelerle gerektiğinde paylaşılabilir.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">5. Veri Güvenliği</h2>
            <p>
              Verilerinizi korumak için endüstri standardı güvenlik önlemleri kullanıyoruz. 
              SSL şifreleme, güvenli sunucular ve düzenli güvenlik denetimleri bunlardan bazılarıdır.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">6. Haklarınız</h2>
            <p>
              KVKK kapsamında aşağıdaki haklara sahipsiniz:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Verilerinize erişim hakkı</li>
              <li>Verilerinizi düzeltme hakkı</li>
              <li>Verilerinizin silinmesini talep etme hakkı</li>
              <li>Veri işlemeye itiraz etme hakkı</li>
            </ul>

            <h2 className="text-xl font-semibold mt-8 mb-4">7. İletişim</h2>
            <p>
              Gizlilik politikamız hakkında sorularınız için{' '}
              <a 
                href="https://www.instagram.com/excelvbamakro/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-blue-600 hover:text-blue-800 inline-flex items-center"
              >
                Instagram hesabımız
                <svg className="w-4 h-4 ml-1" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z" />
                  <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z" />
                </svg>
              </a>{' '}
              üzerinden bizimle iletişime geçebilirsiniz.
            </p>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default Privacy; 